import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { Parameter } from "../models/Parameter";
import { CreateSupplierQuotationDTO } from "../models/Quotation/CreateSupplierQuotationDTO";
import { EditQuotationDTO } from "../models/Quotation/EditQuotationDTO";
import { PartsAndServicesQuotationDTO } from "../models/Quotation/PartsAndServicesQuotationDTO";
import { SupplierQuotationDTO } from "../models/Quotation/SupplierQuotationDTO";
import { UpdateStatusRequestDTO } from "../models/Status/UpdateStatusRequestDTO";
import { APIService } from "./APIService";

export class SupplierQuotationService {
    async Create(data: CreateSupplierQuotationDTO): Promise<MessagingHelper<number>> {
        try {
          var response = await APIService.Axios().post(
            `${APIService.GetURL()}/SupplierQuotation/Create`,
            {
              ...data,
            },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + APIService.GetToken(),
              },
            }
          );
          return response.data;
        } catch (error) {
          return new MessagingHelper<number>(
            false,
            "Erro ao ligar ao servidor para criar o pedido de cotação do fornecedor",
            0
          );
        }
      }
      async GetAll(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<SupplierQuotationDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/SupplierQuotation/GetAll`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<SupplierQuotationDTO>(
                false,
                "Erro ao ligar ao servidor ao obter a informação dos pedidos de cotação ao fornecedor",
                "",
                [],
                0,
            );
        }
    }

    async GetById(id: number): Promise<MessagingHelper<SupplierQuotationDTO | null>> {
      try {
          var response = await APIService.Axios().get(
              `${APIService.GetURL()}/SupplierQuotation/${id}`,
              {
                  headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + APIService.GetToken(),
                  },
              },
          );
          return response.data;
      } catch (error) {
          return new MessagingHelper<null>(
              false,
              "Erro ao ligar ao servidor ao obter a informação do pedido de cotação ao fornecedor",
              null
          );
      }
    }

    async Edit(id: number, data: EditQuotationDTO): Promise<MessagingHelper<SupplierQuotationDTO | null>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/SupplierQuotation/Edit/${id}`,
                data, 
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error: any) {
            console.error('Error response:', error.response);
            return new MessagingHelper<SupplierQuotationDTO | null>(
                false,
                "Erro ao ligar ao servidor para editar o pedido de cotação do fornecedor",
                null
            );
        }
    }
    async UpdateStatus(id:number, request: UpdateStatusRequestDTO): Promise<MessagingHelper<SupplierQuotationDTO | null>> {
        try {
          var response = await APIService.Axios().post(
            `${APIService.GetURL()}/SupplierQuotation/UpdateStatus/${id}`,
              request,
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + APIService.GetToken(),
              },
            }
          );
          return response.data;
        } catch (error) {
          return new MessagingHelper<SupplierQuotationDTO | null>(
            false,
            "Erro ao ligar ao servidor para atualizar o estado do pedido de cotação do fornecedor",
            null
          );
        }
      }

      async DeleteParts(id:number, partId: number): Promise<MessagingHelper<SupplierQuotationDTO | null>> {
        try {
          var response = await APIService.Axios().post(
            `${APIService.GetURL()}/SupplierQuotation/DeleteParts/${id}`,
              partId,
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + APIService.GetToken(),
              },
            }
          );
          return response.data;
        } catch (error) {
          return new MessagingHelper<SupplierQuotationDTO | null>(
            false,
            "Erro ao ligar ao servidor para eliminar artigo do pedido de cotação ao fornecedor",
            null
          );
        }
      }
}
